import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import withStyles from "isomorphic-style-loader/withStyles";
import { Container } from "react-bootstrap";

import { addOrderAction } from "../../actions/order/addOrderAction";
import { readGuestCart, clearGuestCart } from "../../helpers/bookingDraft";
import history from "../../history";
import messages from "../../locale/messages";
import ViewBookingSkeleton from "../../components/Skeleton/ViewBooking/ViewBookingSkeleton/ViewBookingSkeleton";
import bt from '../../components/commonStyle.css';

// /order/replay — the post-login landing for a guest who filled the cart while logged out.
// It takes the cart stashed in sessionStorage (writeGuestCart) and creates the REAL order via the
// existing, user-scoped addOrderAction (server still enforces request.user.id in addOrderWhole).
// addOrderAction pushes to /order/:id on success, so the now-authenticated user continues the flow
// exactly as if they had been logged in the whole time. ADDITIVE: no server change, no guest order.
const GuestCartReplay = () => {
    const dispatch = useDispatch();
    const ranRef = useRef(false);

    useEffect(() => {
        if (ranRef.current) return; // replay exactly once
        ranRef.current = true;
        const cart = readGuestCart();
        if (!cart) {
            // Nothing to replay (direct hit / already consumed) — bounce to the booking entry point.
            history.replace('/category');
            return;
        }
        clearGuestCart();
        // addOrderAction redirects to /order/:id on success (or toasts + stays on error).
        dispatch(addOrderAction(cart));
    }, [dispatch]);

    return (
        <div className={'subPageContainer'}>
            <Container>
                <div className={bt.space3}>
                    <FormattedMessage {...messages.loadingText} />
                </div>
                <ViewBookingSkeleton />
            </Container>
        </div>
    );
};

export default injectIntl(withStyles(bt)(GuestCartReplay));
